import AssessmentQuestionV1 from "../../../../components/form_builder/elements/assessment_question/AssessmentQuestionV1.vue";
import { validateRequired } from "../../../../helpers/validation";

export default {
  componentName: "fb-assessment-question-v1",
  component: AssessmentQuestionV1,
  defaultAttrs: {
    properties: {
      question: "Question",
      answers: [],
      description: "",
      value: "",
      required: false,
      hidden: false,
      showInline: false,
      style: {},
      eFormEditable: true
    }
  },
  gridAttrs: {
    type: "template",
    width: 120,
    template: ({ value }) => value
  },
  getValueReport: value => {
    return value;
  },
  validate: ({ value, properties }) => {
    const errors = [];
    if (properties.required && !validateRequired(value))
      errors.push("This field is required");
    return errors;
  }
};
